import { render } from "./BaseSwitch.vue?vue&type=template&id=0ebe7c76"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src407097413/src/Abbott-Seguimiento-Email-Backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__